<template>
  <div class="my-nav pl-0 pr-0" id="home">
    <b-container>
      <b-navbar id="navbar" toggleable="md">
        <b-navbar-toggle target="collapse-area"></b-navbar-toggle>
        <b-navbar-brand class="d-md-none">
          <a href="/#home">
            <img
              class="navbar-logo"
              src="./../assets/logo-mustata-color.png"
              alt="Logo Mustata"
            />
          </a>
        </b-navbar-brand>
        <b-collapse id="collapse-area" is-nav>
          <b-container class="pl-0 pr-0">
            <div class="main-nav-holder">
              <div class="nav-section">
                <b-nav-item href="/#home">Acasă</b-nav-item>
                <b-nav-item href="/#about">Poveste</b-nav-item>
                <!-- <b-nav-item href="/#comunity">Comunitate</b-nav-item> -->
                <b-nav-item href="/#ingredients">Ingrediente</b-nav-item>
                
              </div>

              <div class="d-none d-md-block text-center">
                <b-nav-item href="/#home">
                  <img
                    class="navbar-logo"
                    src="./../assets/logo-mustata-color.png"
                    alt="Logo Mustata"
                  />
                </b-nav-item>
              </div>

              <div class="nav-section">
                <b-nav-item href="/#comunity">Comunitate</b-nav-item>
                <b-nav-item>
                  <router-link :to="{ path: '/parteneri/' }"
                    >Parteneri</router-link
                  >
                </b-nav-item>

                <!-- <b-nav-item>
                  <router-link :to="{ path: '/concurs/' }">Concurs</router-link>
                </b-nav-item> -->

                <b-nav-item href="/#contact">Contact</b-nav-item>
              </div>
            </div>
          </b-container>
        </b-collapse>
      </b-navbar>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Navbar",
};
</script>

<style>

a.router-link-exact-active.router-link-active {
  color: black;
  text-transform: uppercase;
  font-weight: 600;
}

a.router-link-exact-active.router-link-active:hover, a.nav-link:hover {
  text-decoration: none;
  color: #8b4e2e;
}

.my-nav {
  position: sticky;
  top: 0px;
  z-index: 200;
  background-color: white;
}

li.nav-item {
  list-style: none;
}

a.nav-link {
  color: black;
  text-transform: uppercase;
  font-weight: 600;
}

.navbar-logo {
  margin: 0 20px;
  width: 75px;
  height: 75px;
}

.main-nav-holder {
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;
}

.nav-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
}

@media (max-width: 767.98px) {
  .nav-section {
    flex-direction: column;
  }

  .main-nav-holder {
    flex-direction: column;
    font-size: 12px;
  }
}

@media (max-width: 990px) and (min-width: 720px) {
  a.nav-link {
    font-size: 12px;
  }
}
</style>